import Rating, { RatingProps } from '@mui/material/Rating';
import StarRoundedIcon from '@mui/icons-material/StarRounded';

type SupportRatingProps = Omit<RatingProps, 'icon' | 'emptyIcon' | 'sx'> & {
  centerOnMobile?: boolean;
};

const SupportRating = ({ centerOnMobile = false, ...props }: SupportRatingProps) => (
  <Rating
    {...props}
    icon={<StarRoundedIcon fontSize="inherit" />}
    emptyIcon={<StarRoundedIcon fontSize="inherit" />}
    sx={{
      alignSelf: centerOnMobile ? { xs: 'center', sm: 'flex-start' } : undefined,
      fontSize: { xs: '2.65rem', sm: '3rem' },
      color: '#f59e0b',
      '& .MuiRating-icon': { mx: { xs: 0.1, sm: 0.25 } },
      '& .MuiRating-iconEmpty': { color: 'action.disabled' },
    }}
  />
);

export default SupportRating;
